/**
 * Client build-staleness bar — must exceed server heartbeat cadence (~120s) + poll jitter;
 * healthy inter-batch gaps of 90-150s are normal.
 */
export const HEARTBEAT_STALE_MS = 180_000;

export function resolveBuildHeartbeatRef(
  buildLastProgressAt?: string | null,
  buildStartedAt?: string | null,
): number | null {
  const lastProgress = Date.parse(String(buildLastProgressAt || ''));
  if (Number.isFinite(lastProgress)) return lastProgress;
  const startedAt = Date.parse(String(buildStartedAt || ''));
  if (Number.isFinite(startedAt)) return startedAt;
  return null;
}

/** True when the server reports building but its heartbeat is older than HEARTBEAT_STALE_MS. */
export function isBuildHeartbeatStale(
  buildStatus: string,
  buildLastProgressAt?: string | null,
  nowMs = Date.now(),
  buildStartedAt?: string | null,
): boolean {
  if (buildStatus !== 'building') return false;
  const ref = resolveBuildHeartbeatRef(buildLastProgressAt, buildStartedAt);
  if (ref == null) return false;
  return nowMs - ref >= HEARTBEAT_STALE_MS;
}
